import React, { useContext, useEffect, useState } from 'react';
import _UserList from "./_UserList";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from "@mui/material";
import {
    BadgeRounded,
    CloseRounded,
    GroupWorkRounded,
    PeopleAltRounded,
    PersonAddRounded,
    PhoneIphoneRounded
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { corporatePersonnel_add, corporatePersonnel_query } from "../../network/api/corporatePersonnel.api";
import { ErrorContext } from "../../components/GympinPagesProvider";
import Grid from "@mui/material/Grid2";
import _UsersActions from "../../components/_UsersActions";
import { useNavigate } from "react-router-dom";
import { checkMobileValid, fixFarsiNumbers, fixMobile } from "../../helper/utils";
import { getRppPersonnel } from "../../helper/pocket";

const NewUserPage = () => {
    const error = useContext(ErrorContext);
    const navigate = useNavigate();
    const corporate = useSelector(({ corporate }) => corporate.corporate);
    const [page, setPage] = useState(0);
    const [personnel, setPersonnel] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(() => getRppPersonnel() || 10);
    const [searchText, setSearchText] = useState(undefined);
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [sortBy, setSortBy] = useState({ Name: "Id", Desc: false });

    // Add personnel form state
    const [phoneNumber, setPhoneNumber] = useState("");
    const [fullName, setFullName] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        getPersonnel();
    }, [selectedGroup, page, rowsPerPage, searchText, sortBy]);

    function handleOpenModal() {
        setPhoneNumber("");
        setFullName("");
        setOpenModalAdd(true);
    }

    function handlePhoneChange(e) {
        let val = fixFarsiNumbers(e.target.value);
        if (val.length <= 11) {
            setPhoneNumber(val);
        }
    }

    function addPersonnel(e) {
        e.preventDefault();
        const normalizedPhone = fixMobile(phoneNumber);

        if (personnel?.content?.length > 1 && (corporate?.Status === "DEMO" || corporate?.Status === "SECURE_DEMO")) {
            error.showError({ message: "برای نسخه نمایشی (Demo) بیش از ۲ کاربر امکان‌پذیر نیست" });
            return;
        }

        if (!checkMobileValid(normalizedPhone)) {
            error.showError({ message: "شماره موبایل وارد شده صحیح نیست (مثال: 09121234567)" });
            return;
        }

        setSubmitting(true);
        corporatePersonnel_add({
            Corporate: { Id: corporate?.Id },
            PhoneNumber: normalizedPhone,
            FullName: fullName.trim()
        }).then(() => {
            setSubmitting(false);
            setOpenModalAdd(false);
            getPersonnel();
        }).catch(err => {
            setSubmitting(false);
            try {
                error.showError({ message: err.response?.data?.Message || "خطا در ثبت پرسنل" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    function renderModalAdd() {
        return (
            <Dialog
                open={openModalAdd}
                onClose={() => !submitting && setOpenModalAdd(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        p: 1,
                        boxShadow: '0 20px 45px rgba(0,0,0,0.12)'
                    }
                }}
            >
                <Box component="form" onSubmit={addPersonnel}>
                    <DialogTitle
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            pb: 1.5,
                            borderBottom: '1px solid',
                            borderColor: 'divider'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: 3,
                                    bgcolor: 'rgba(28, 139, 156, 0.1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'primary.main'
                                }}
                            >
                                <PersonAddRounded />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.1rem' }}>
                                    افزودن کارمند جدید
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    اطلاعات پرسنل را جهت عضویت و تخصیص اعتبار وارد کنید
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton
                            size="small"
                            onClick={() => setOpenModalAdd(false)}
                            disabled={submitting}
                            sx={{ color: 'text.secondary' }}
                        >
                            <CloseRounded fontSize="small" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent sx={{ pt: 3 }}>
                        <TextField
                            autoFocus
                            label="شماره موبایل کارمند"
                            placeholder="۰۹۱۲۳۴۵۶۷۸۹"
                            margin="normal"
                            name="PhoneNumber"
                            type="tel"
                            value={phoneNumber}
                            onChange={handlePhoneChange}
                            fullWidth
                            required
                            dir="ltr"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PhoneIphoneRounded sx={{ color: 'text.secondary', fontSize: 20 }} />
                                    </InputAdornment>
                                ),
                                sx: { borderRadius: 2.5 }
                            }}
                            helperText="شناسه ورود کارمند به اپلیکیشن جیم‌پین"
                        />

                        <TextField
                            label="نام و نام خانوادگی (اختیاری)"
                            placeholder="مثال: علی محمدی"
                            margin="normal"
                            name="FullName"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <BadgeRounded sx={{ color: 'text.secondary', fontSize: 20 }} />
                                    </InputAdornment>
                                ),
                                sx: { borderRadius: 2.5 }
                            }}
                            sx={{ mt: 2 }}
                        />
                    </DialogContent>

                    <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                        <Button
                            variant="text"
                            onClick={() => setOpenModalAdd(false)}
                            disabled={submitting}
                            sx={{ borderRadius: 2.5, px: 2.5, color: 'text.secondary' }}
                        >
                            انصراف
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            disabled={submitting || !phoneNumber}
                            sx={{
                                borderRadius: 2.5,
                                px: 3.5,
                                py: 1,
                                fontWeight: 700,
                                boxShadow: '0 4px 14px rgba(28, 139, 156, 0.25)'
                            }}
                        >
                            {submitting ? (
                                <CircularProgress size={22} color="inherit" />
                            ) : (
                                "ثبت و افزودن کارمند"
                            )}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        );
    }

    function getPersonnel() {
        if (!corporate?.Id) return;
        setPersonnel(null);
        corporatePersonnel_query({
            queryType: "FILTER",
            CorporateId: corporate?.Id,
            FullName: searchText,
            GroupId: selectedGroup,
            paging: { Page: page, Size: rowsPerPage, orderBy: sortBy.Name, Desc: !sortBy.Desc }
        }).then(result => {
            setPersonnel(result.data.Data);
        }).catch(e => {
            setPersonnel(null);
            try {
                error.showError({ message: e.response?.data?.Message || "خطا در دریافت لیست پرسنل" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    return (
        <>
            <title>مدیریت کارمندان | جیم‌پین سازمانی</title>
            <Container maxWidth="xl" sx={{ pt: 3, pb: 4 }}>
                {/* Executive Page Header */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        justifyContent: 'space-between',
                        gap: 2,
                        mb: 3.5,
                        p: { xs: 2.5, md: 3 },
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box
                            sx={{
                                width: 54,
                                height: 54,
                                borderRadius: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'primary.main',
                                color: '#fff',
                                boxShadow: '0 8px 20px rgba(45, 107, 226, 0.3)',
                            }}
                        >
                            <PeopleAltRounded sx={{ fontSize: 32 }} />
                        </Box>
                        <Box>
                            <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                                مدیریت پرسنل و کارمندان
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                مشاهده، ثبت و مدیریت اطلاعات کارکنان و اعتبارات تخصیص‌یافته
                            </Typography>
                        </Box>
                    </Box>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PersonAddRounded sx={{ ml: 1, mr: -0.5 }} />}
                        onClick={handleOpenModal}
                        sx={{
                            borderRadius: 3,
                            px: 3,
                            py: 1.2,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(45, 107, 226, 0.3)',
                        }}
                    >
                        افزودن کارمند جدید
                    </Button>
                </Box>

                {/* Top Action Cards */}
                <Grid container columns={12} spacing={2.5} alignItems="stretch">
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <_UsersActions
                            title="افزودن کارمند جدید"
                            description="ثبت پرسنل جدید با شماره همراه و مشخصات جهت تخصیص اعتبار"
                            icon={<PersonAddRounded sx={{ fontSize: 30, color: 'primary.main' }} />}
                            onClick={handleOpenModal}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <_UsersActions
                            title="دسته‌بندی و تگ‌های پرسنل"
                            description="دسته‌بندی پرسنل، تعریف دپارتمان‌ها و تخصیص تگ‌ها و اعتبارهای رفاهی"
                            icon={<GroupWorkRounded sx={{ fontSize: 30, color: 'primary.main' }} />}
                            onClick={() => navigate("/personnel/groups")}
                        />
                    </Grid>
                </Grid>

                {/* Personnel List Table */}
                <_UserList
                    selectedGroup={selectedGroup}
                    setSelectedGroup={setSelectedGroup}
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    personnel={personnel}
                    corporate={corporate}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    page={page}
                    setPage={setPage}
                    setSearchText={setSearchText}
                />
            </Container>

            {renderModalAdd()}
        </>
    );
};

export default NewUserPage;

